import Vue from 'vue'

// initial state
const state = () => ({
  defaultRow: 50,
  storageKey: '{sellerId}-settingPaginationRows',
  paginationRows: {}
})

// getters
const getters = {
  getPaginationRow: (state) => (screenKey) => {
    if (!state.paginationRows || typeof state.paginationRows !== 'object') {
      return state.defaultRow
    }
    return state.paginationRows[screenKey] || state.defaultRow
  }
}

// actions
const actions = {
  getStorageSettingPaginationRows ({ commit, rootState }) {
    const key = state().storageKey.replace('{sellerId}', rootState.user.user.sellerId)
    const saved = localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : {}
    if (saved && typeof saved === 'object' && !Array.isArray(saved)) {
      commit('savePaginationRows', { sellerId: rootState.user.user.sellerId, data: saved })
    } else {
      commit('savePaginationRows', { sellerId: rootState.user.user.sellerId, data: {} })
    }
  },
  updatePaginationRow ({ commit, rootState }, { screen, row }) {
    commit('setPaginationRow', { sellerId: rootState.user.user.sellerId, screen, row })
  }
}

// mutations
const mutations = {
  setPaginationRow (state, { sellerId, screen, row }) {
    Vue.set(state.paginationRows, screen, row)
    const key = state.storageKey.replace('{sellerId}', sellerId)
    localStorage.setItem(key, JSON.stringify(state.paginationRows))
  },
  savePaginationRows (state, { sellerId, data }) {
    state.paginationRows = data
    const key = state.storageKey.replace('{sellerId}', sellerId)
    localStorage.setItem(key, JSON.stringify(state.paginationRows))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pagination.js